<template>
  <div id="TOC">
    <div id="TOCContent">
      <div id="TOCContainer">
        <div id="TOCImageText">
          <p>Based on your answers, we've added a <img style="vertical-align: text-top;" src="@/assets/img/TOC_reviewIcon.png"/> next to each topic to which you should pay special attention. The icon will disappear once you have viewed all the questions under that topic.</p>
          <p>Here are the different topics to review and some common questions associated with each.</p>
        </div>
      </div>
      <div id="TOCQuestions">
        <div class="TOCQuestionContainer" v-for="(uniqueMod, index) in uniqueModules" :key="'module-' + index">
          <div class="moduleName" @click="toggleModule(uniqueMod)">
            <div class="dropDownArrow" :class="{rotateArrow: (uniqueMod.module === currentModule && openModule === currentModule)}"><img src="@/assets/img/TOC_Arrow.png"></div>
            <div class="moduleNameText" v-html="uniqueMod.module" :class="{star: uniqueMod.starred, viewedAll: viewedAll(uniqueMod)}" ></div>
          </div>

          <div class="container" :class="{noPadding: !(uniqueMod.module === currentModule && openModule === currentModule)}">
            <div class="TOCQuestion" v-for="(modQuestion, questionIndex) in uniqueMod.questions" v-show="(uniqueMod.module === currentModule && openModule === currentModule)" :key="'moduleQuestion-' + index + '-' + questionIndex">
              <div class="currentlyViewing">
                <template v-if="currentModuleQuestion === modQuestion.id">
                  <div class="circleRing"></div>
                  <div class="circle"></div> 
                </template>
              </div>

              <div class="moduleQuestion" v-html="modQuestion.question" @click="changeModuleQuestion(modQuestion)" :class="{curModule: currentModuleQuestion === modQuestion.id, star: (sectionsToReview.includes(modQuestion.id) && !viewedQuestion(modQuestion.id))}">
              </div>
              <div class="questionViewed" v-if="viewedQuestion(modQuestion.id)" >
                <img src="@/assets/img/TOC_completeIcon.png"/> <i>viewed</i>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div id="TOCFooter">
        <p>Need urgent help with a launch?<br/>Email us at <a href="mailto:info@cldinc.com" target="_blank">info@cldinc.com</a> </p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'TableOfContents',
  props: {
    
  },
  computed: {
    ...mapGetters([
      'pretestQuestions',
      'pretestAnswers',
      'mobileMentorQuestions',
      'currentModule',
      'currentModuleQuestion',
      'completed',
      'requiresAttestation',
      'hasMobileMentor',
      'hasPretest',
      'showTOC',
      'viewedQuestions',
      'moduleAssetFolderName',
      'hasBibliography',
      'hasGlossary',
      'sectionsToReview',
    ]),
  },
  methods: {
    ...mapActions([
      'hideResults',
      'displayResults',
      'openModal',
      'completeModule',
      'changeModule',
      'changeModuleQuestion',
    ]),
    viewedQuestion(questionID){
      let theTOC = this;
      return theTOC.viewedQuestions.includes(questionID)
    },
    viewedAll(theModule){
      let theTOC = this;
      let viewedAll = true;
      theModule.ids.forEach(id => {
        if(!theTOC.viewedQuestions.includes(id)){
          viewedAll = false;
        }
      });
      return viewedAll;
    },
    toggleModule(uniqueModule){
      let theTOC = this;
      theTOC.openModule = theTOC.openModule === uniqueModule.module ? '' : uniqueModule.module
      theTOC.changeModule(uniqueModule.module)
    },
    launchReferences(){
      let theTOC = this;
      window.open(`./assets/modules/${theTOC.moduleAssetFolderName}/Bibliography.pdf`)
    },
    launchGlossary(){
      let theTOC = this;
      window.open(`./assets/modules/${theTOC.moduleAssetFolderName}/Glossary.pdf`)
    },
  },
  mounted(){
    let theTOC = this;

    let matchingModule = null;
    let matchingModuleIndex = -1;
    theTOC.sectionsToReview.forEach(sectionToReview => {
      matchingModule = theTOC.mobileMentorQuestions.find(mmQuestion => mmQuestion.id === sectionToReview);
      if(matchingModule){
        matchingModuleIndex = theTOC.modsStarred.findIndex(starredMod => starredMod.module === matchingModule.module);
        if(matchingModuleIndex === -1){
          theTOC.modsStarred.push({
            module: matchingModule.module,
            sections: [sectionToReview]
          });
        }else{
          theTOC.modsStarred[matchingModuleIndex].sections.push(sectionToReview)
        }
      }
    });

    // sort module sections
    theTOC.modsStarred.forEach((module, index) => {
      theTOC.modsStarred[index].sections.sort()
    })

    // build list of unique mods
    theTOC.mobileMentorQuestions.forEach(question => {
      let currentModName = question.module;
      let currentModIndex = theTOC.uniqueModules.findIndex(uniqueMod => uniqueMod.module === currentModName);
      let currentQuestionID = question.id;

      if(currentModIndex === -1){
        theTOC.uniqueModules.push({
          module: currentModName,
          questions: [
            {
              id: currentQuestionID,
              question: question.question_text
            }
          ],
          ids: [
            currentQuestionID
          ],
          starred: (theTOC.modsStarred.findIndex(starredMod => starredMod.module === currentModName) !== -1)
        });
      }else{
        theTOC.uniqueModules[currentModIndex].questions.push({
          id: currentQuestionID,
          question: question.question_text
        });

        theTOC.uniqueModules[currentModIndex].ids.push(currentQuestionID);
      }
    })

    // set open module if currently on a question
    if(theTOC.currentModuleQuestion){
      theTOC.openModule = theTOC.uniqueModules.find(uniqueModule => uniqueModule.ids.includes(theTOC.currentModuleQuestion)).module;
    }

  },
  data(){
    return {
      modsStarred: [],
      uniqueModules: [],
      openModule: ''
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.star::after{
  content: url('../assets/img/TOC_reviewIcon.png');
  margin-left: 20px;
}

.viewedAll::after{
  /*content: url('../assets/img/TOC_reviewIcon_check.png');*/
  content: none;
  /*float: right;*/
  margin-left: 20px;
}


#TOCContainer{
  /*height: 200px;*/
  background-color: #f6f6f6;
}

#TOCFooter{
  font-weight: bold;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  text-align: center;
}

#TOCImageContainer{
  /*width: 20%;*/
  /*float: left;*/
}

#TOCImage{
  /*position: relative;*/
  /*top: 20px;*/
  /*left: 20px;*/
  /*max-width: 150px;*/
  /*height: 150px;*/
}

#TOCImageText{
/*  width: 75%;
  float: left;
  padding: 10px 10px 10px 20px;*/
  padding: 15px;
  text-align: center;
}

#TOCImageText > p{
  font-size: 18px;
  font-weight: bold;
}

#TOCImageText > p:last-of-type{
  margin-bottom:0px;
}

#retakePretest{
  color: #055272;

}
#TOC{
  top: 50px;
  position: fixed;
  right: 0;
  width: 80%;
  max-width: 900px;
  height: calc(100% - 50px);
  overflow-y: hidden;
  z-index: 4;
  overflow-x: hidden;
}
#TOCContent{
  position: relative;
  display: block;
  width: 100%;
  height: 100%;
  background-color: white;
  float: right;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.moduleName{
  background-color: #ffffff;
  color: #009ddd;
  font-family: MontserratBold;
  text-transform: uppercase;
  padding: 10px 25px;
  cursor: pointer;

}

.pdf-link{
  background-color: #ffffff;
  color: #009ddd;
  font-family: MontserratBold;
  text-transform: uppercase;
  padding: 5px 25px;
  cursor: pointer;
}

.moduleNameText{
  display: flex;
  align-items: center;
}

.curModule{
  color: #6B9B31;
  font-weight: bold;
}

.dropDownArrow{
  float: left;
  width: 30px;
  text-align: center;
}

.rotateArrow{
  -ms-transform: rotate(90deg); 
  -webkit-transform: rotate(90deg); 
  transform: rotate(90deg); 
}
.TOCQuestionContainer{
  height: auto;
  border-bottom: 1px solid #f3f4f4;
  display: block;
  overflow: auto;
  float: left;
  width: 100%;
  padding: 5px 0px;
}

.TOCQuestionContainer:last-of-type{
  margin-bottom:20px;
}

.TOCQuestion{
  width: 100%;
  min-height: 30px;
  margin-bottom: 10px;
  float: left;
  background-color: #ffffff;
}

.currentlyViewing{
  position: relative;
  float: left;
  width: 50px;
  height: 30px;
  text-align: center;
}

.circle{
  width: 8px;
  height: 8px;
  background-color: #6B9B31;
  border-radius: 50%;
  position: absolute;
  top: 20%;
  left: 23px;
}

.circleRing{
  border: 3px solid #6B9B31;
  border-radius: 30px;
  height: 14px;
  width: 14px;
  position: absolute;
  left: 20px;
  top: 13%;
  animation: pulsate 1s ease-out;
  animation-iteration-count: infinite; 
  opacity: 0.0
}

@keyframes pulsate{
  0% {transform: scale(0.1, 0.1); opacity: 0.0;}
  50% {opacity: 1.0;}
  100% {transform: scale(1.2, 1.2); opacity: 0.0;}
}

.moduleQuestion{
  cursor: pointer;
  max-width: 80%;
  float: left;
  box-sizing: border-box;
}

.questionViewed{
  float: left;
  margin-left: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
}

@media(max-width: 900px){
  #TOCImageContainer{
    display: none;
  }
  #TOCImageText{
    width: 100%;
    padding: 5px 10px 5px 0px;
  }
  #TOCImageText > p{
    font-size: 16px;
  }
  #TOCContainer{
    text-align: center;
  }
}

.TOCQuestionContainer > .container.noPadding{
  padding: 0px !important;
}
</style>
